export default __webpack_public_path__ + "static/Fathi Amin-dca0dacd1452025614aee2b0ab1a9b48.webp";